import { keepPreviousData } from '@tanstack/react-query';
import { useQuery } from '@src/shared/query';
import type { UseQueryParams } from '@src/features/types';
import { resourceUserFromDto } from '../../lib';
import type { ResourceUser, ResourceUserDto } from '../../types';
import { resourceUsersUrl } from './constants';

export type ResourceUserQueryParams = Partial<{
  page_size: number;
}>;

export default function useResourceUsers(params: Partial<UseQueryParams> = {}) {
  const { queryParams = {} } = params;
  const query = useQuery<ResourceUserDto[], ResourceUser[]>(
    resourceUsersUrl,
    {
      queryParams,
      select: (data: Array<ResourceUserDto>) => data.map(resourceUserFromDto),
      placeholderData: keepPreviousData,
    },
  );

  const { data: users = [], ...restQuery } = query;
  return {
    users,
    ...restQuery,
  };
}
